import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { borderTop, space } from 'styled-system';

import { borderTopColor, borderTopStyle, borderTopWidth } from 'common/theme/system-utilities';

const UnstyledSeparator = styled.div<any>`
  ${borderTopStyle};
  ${borderTopWidth};
  ${borderTopColor};
  ${borderTop};
  ${space};
`;

const Separator = (props: ComponentProps<typeof UnstyledSeparator>) => (
  <UnstyledSeparator
    borderTopStyle="solid"
    borderTopWidth="small"
    borderTopColor="sys.neutral.border.weak"
    my={['sp_12', null, null, 'sp_16']}
    {...props}
  />
);

export default Separator;
